import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio169: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"aspect-ratio-16-9, landscape"} maskId="square-filled-radius-0-stroke-1-IconAspectRatio169"><path d="M1 5V19H23V5H1Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAspectRatio169;
